export default "__VITE_ASSET__Dzq5hBI$__"